import classNames from 'classnames';
import map from 'lodash/map';
import sum from 'lodash/sum';
import React from 'react';
import {connect} from 'react-redux';
import swal from 'sweetalert2';
import {getUsersRetention} from '../../../../../actions/entities/dailyReport';
import earthFlag from '../../../../../assets/img/other/flag-earth.svg';
import Loader from '../../../../../components/Loader';
import './index.css';

class UsersRetentionWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {lang: 'ALL'};
  }

  fetchStats() {
    const {isFetching} = this.props;
    if (!isFetching) {
      this.props.dispatch(
        getUsersRetention(null, (type, error) =>
          swal({
            title: `Oops...`,
            type: 'error',
            html:
              `Something went wrong:<br/>"${type}"<br/>${error}<br/>` +
              `<pre><code>${JSON.stringify(error, undefined, 4)}</code></pre>`,
          }),
        ),
      );
    }
  }

  toggleLang(value) {
    const {lang} = this.state;

    if (lang === value) {
      this.setState({lang: 'ALL'});
    } else {
      this.setState({lang: value});
    }
  }

  renderTable() {
    const {data} = this.props;
    if (!data) return false;
    const {lang} = this.state;
    const keysList = Object.keys(data.countries[lang]);
    const dataLength = keysList.length;
    const total =
      sum(map(data.countries[lang][keysList[dataLength - 1]].seasons)) -
      data.countries[lang][keysList[dataLength - 1]].signUps;
    return (
      <div className="table-responsive">
        <table className="table table-bordered">
          <thead>
            <tr>
              <th className="text-center">Sign up in season</th>
              {keysList.map((key, index) => {
                return (
                  <th
                    className={classNames(
                      {borderLeft: index + 1 === dataLength},
                      'text-center',
                    )}>
                    {data.countries[lang][key].signUps.toLocaleString()}
                  </th>
                );
              })}
            </tr>
            <tr>
              <th
                className="text-center"
                style={{borderBottom: '2px solid black'}}>
                User running league season
              </th>
              {keysList.map((key, index) => {
                return (
                  <th
                    style={{borderBottom: '2px solid black'}}
                    className={classNames({
                      greenBackground: index % 2 === 0,
                      borderLeft: index + 1 === dataLength,
                    })}>
                    {`user_${key}`}
                  </th>
                );
              })}
            </tr>
            {keysList.map((key, index) => {
              return (
                <tr>
                  <th
                    className={classNames(
                      {
                        greenBackground: index % 2 === 0,
                        borderBottom: index + 1 === dataLength,
                      },
                      'text-center',
                    )}>
                    {key}
                  </th>
                  {keysList.map((k, i) => {
                    if (index < i)
                      return (
                        <th
                          className={classNames({
                            borderLeft: i + 1 === dataLength,
                            borderBottom: index + 1 === dataLength,
                          })}
                          style={{backgroundColor: '#efefef'}}
                        />
                      );
                    return (
                      <th
                        className={classNames('text-center', {
                          borderLeft: i + 1 === dataLength,
                          borderBottom: index + 1 === dataLength,
                        })}>
                        {data.countries[lang][key].seasons[k].toLocaleString()}
                      </th>
                    );
                  })}
                </tr>
              );
            })}
            <tr>
              <th className="text-center">
                % actif selon la saison d'inscription
              </th>
              {keysList.map((k, i) => {
                return (
                  <th
                    className={classNames('text-center', {
                      borderLeft: i + 1 === dataLength,
                    })}>
                    {Math.round(
                      (data.countries[lang][keysList[dataLength - 1]].seasons[
                        k
                      ] /
                        total) *
                        100,
                    )}
                    %
                  </th>
                );
              })}
            </tr>
            <tr>
              <th className="text-center">Tx fidélité saison N-1</th>
              {keysList.map((k, i) => {
                console.log(
                  data.countries[lang][keysList[dataLength - 2]].seasons[k],
                );
                if (!data.countries[lang][keysList[dataLength - 2]].seasons[k])
                  return (
                    <th
                      className={classNames({borderLeft: i + 1 === dataLength})}
                      style={{backgroundColor: '#efefef'}}
                    />
                  );
                return (
                  <th
                    className={classNames('text-center', {
                      borderLeft: i + 1 === dataLength,
                    })}>
                    {Math.round(
                      (data.countries[lang][keysList[dataLength - 1]].seasons[
                        k
                      ] /
                        data.countries[lang][keysList[dataLength - 2]].seasons[
                          k
                        ]) *
                        100,
                    )}
                    %
                  </th>
                );
              })}
            </tr>
            <tr>
              <th className="text-center">Tx d'actif saison</th>
              {keysList.map((k, i) => {
                return (
                  <th
                    className={classNames('text-center', {
                      borderLeft: i + 1 === dataLength,
                    })}>
                    {Math.round(
                      (data.countries[lang][k].seasons[k] /
                        data.countries[lang][k].signUps) *
                        100,
                    )}
                    %
                  </th>
                );
              })}
            </tr>
          </thead>
        </table>
      </div>
    );
  }

  render() {
    const {lang} = this.state;
    const {isFetching} = this.props;

    return (
      <div id="users-funnel-retention">
        <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title pull-left">
              <i className="fa fa-user-circle-o" /> Users rentention
            </h3>
            <br />
          </div>
          <div className="box-body">
            <div className="margin-bottom text-center">
              <div className="inline lang">
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'FR',
                  })}
                  onClick={() => this.toggleLang('FR')}>
                  <span className="flag-icon flag-icon-fr" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'GB',
                  })}
                  onClick={() => this.toggleLang('GB')}>
                  <span className="flag-icon flag-icon-gb" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'ES',
                  })}
                  onClick={() => this.toggleLang('ES')}>
                  <span className="flag-icon flag-icon-es" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'OTHER',
                  })}
                  onClick={() => this.toggleLang('OTHER')}>
                  <img
                    src={earthFlag}
                    alt="Drapeau de la terre"
                    className="flag-img-btn"
                  />
                </button>
              </div>
              <div className="inline data-range-picker">
                <button
                  className="btn btn-default"
                  onClick={() => this.fetchStats()}>
                  <i className="fa fa-refresh" />
                </button>
              </div>
            </div>
            {}
          </div>
          {this.renderTable()}
          {isFetching && <Loader />}
        </div>
      </div>
    );
  }
}

export default connect(
  state => state.app.statistics.usersRetention,
  dispatch => ({dispatch}),
)(UsersRetentionWidget);



// WEBPACK FOOTER //
// ./src/pages/Monitoring/Statistics/Widgets/UsersRetention/index.js